
import { ref, toRefs } from 'vue'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import Button from 'primevue/button'

export default {
  components: {
    SelectAsync,
    Button
  },
  props: {
    selected: {
      default: { label: 'Nama', value: 'FullName', id: null }
    },
  },
  emits: ['selectSearchOption'],
  setup(props: any, { emit } : any) {
    const documentTypesEndpoint = '/talent/v1/DocumentTypes'
    const {
      selected
    } = toRefs(props)
    const options = ref([
      { label: 'Nama', value: 'FullName' },
      { label: 'Kode Karyawan Lama', value: 'OldPersonnelNumber', id: null },
      { label: 'Kode Karyawan Baru', value: 'PersonnelNumber', id: null },
      // { label: 'NIK', value: 'DocumentSearch', typeName: 'KTP' },
      // { label: 'SIM', value: 'DocumentSearch', typeName: 'SIM' },
    ])
    const selectedOptions = ref(!props.selected?.id ? props.selected : null) as any
    const selectedDocumentType = ref(props.selected?.id ? props.selected : null) as any

    const selectOptionAct = (val: any) => {
      console.log('val', val)
      if (val?.id) {
        selectedDocumentType.value = val
        selectedOptions.value = null
      } else {
        selectedOptions.value = val
        selectedDocumentType.value = null
      }
      // selectedOptions.value = val
      // selectedDocumentType.value = null
    }

    const resetSearch = () => {
      console.log('resetSearch')
    }

    const applySearch = (evt: any) => {
      console.log('applySearch', selectedOptions.value)
      const value = selectedOptions.value ?? selectedDocumentType.value
      console.log('valueApply', value)
      emit('selectSearchOption', evt, value)
    }

    return {
      selectOptionAct,
      selected,
      options,
      selectedOptions,
      documentTypesEndpoint,
      resetSearch,
      applySearch,
      selectedDocumentType
    }
  }
}

